/**
 * The **public origin's** browser entry point: the entry journey and the
 * questionnaire, and nothing else.
 *
 * Authority: bead scope-njw for the seam; the two-origin split for why there
 * are two of these. The staff and admin planes are served from a separate
 * Static Web App behind Entra — see `main.staff.tsx` and
 * `staticwebapp.staff.config.json`.
 *
 * **`StaffAuthProvider` is deliberately absent, and MSAL with it.** It used to
 * be mounted here and cost a customer nothing at runtime, because it engaged
 * only on a staff-plane path. It costs them something at *build* time: MSAL and
 * every module it reaches were in this bundle, and so was every staff screen
 * the registry named. Nothing on this origin can reach the staff plane now, so
 * the provider that serves it does not belong in this graph.
 *
 * That is also why this origin's CSP can drop `login.microsoftonline.com`
 * entirely (`staticwebapp.config.json`): no code here talks to Entra.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@nimer/portal-ui/tokens.css'
import '@nimer/portal-ui/tokens.portal.css'

import { App } from './App.tsx'
import { CustomerAuthProvider } from '../auth/CustomerAuthProvider.tsx'
import { setActiveRegistry } from '../routes/_registry/registry.active.ts'
import { registry } from '../routes/_registry/registry.customer.generated.ts'
import { applyDocumentLocale } from '../shell/document.ts'
import { installStaleChunkRecovery } from '../shell/staleChunk.ts'

setActiveRegistry(registry)

// A tab open across a deploy asks for chunk names that no longer exist; without
// this it renders a blank page instead (see `staleChunk.ts`).
installStaleChunkRecovery(window)

const container = document.getElementById('root')
if (container === null) throw new Error('#root is missing from index.html')

applyDocumentLocale(document)
createRoot(container).render(
  <StrictMode>
    <CustomerAuthProvider>
      <App />
    </CustomerAuthProvider>
  </StrictMode>,
)
